import { ArrowUpRight, Play } from "lucide-react";
import { formatEpisodeDate, type PodcastEpisode } from "@/lib/podcast";

export function EpisodeCard({ episode, featured = false }: { episode: PodcastEpisode; featured?: boolean }) {
  const url = `https://www.youtube.com/watch?v=${episode.videoId}`;
  return (
    <article className="group min-w-0">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Obejrzyj odcinek: ${episode.title} (YouTube, nowa karta)`}
        className="relative block aspect-video overflow-hidden bg-ink/5"
      >
        <img
          src={`https://i.ytimg.com/vi/${episode.videoId}/hqdefault.jpg`}
          alt=""
          width={480}
          height={360}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 motion-safe:group-hover:scale-[1.03]"
        />
        <span className="absolute bottom-4 left-4 flex size-12 items-center justify-center rounded-full bg-primary text-primary-foreground transition-transform motion-safe:group-hover:scale-110">
          <Play aria-hidden="true" className="fill-current" />
        </span>
      </a>
      <div className="mt-5 border-t border-steel pt-4">
        <p className="text-sm text-ink-soft">
          <time dateTime={episode.published}>{formatEpisodeDate(episode.published)}</time> · Cały odcinek
        </p>
        <h3 className={`mt-2 leading-snug text-ink ${featured ? "text-xl md:text-2xl" : "text-lg md:text-xl"}`}>
          <a href={url} target="_blank" rel="noopener noreferrer" className="hover:underline">
            {episode.title}
          </a>
        </h3>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-coral-text hover:underline"
        >
          Obejrzyj na YouTube <ArrowUpRight aria-hidden="true" className="size-4" />
        </a>
      </div>
    </article>
  );
}
